import React from 'react';
import './Navigation.css';
import { Navbar,Nav } from 'react-bootstrap';
import {Link} from "react-router-dom";
 
function Navigation() {
  return (
<Navbar collapseOnSelect expand="" bg="dark" variant="dark" fixed="top">
<Navbar.Brand as={Link} to="/" href="#Home">Claire Hutchinson: <span className="brandSubTitle">Screenwriter, Script Analyst, Producer</span></Navbar.Brand>
<Navbar.Toggle aria-controls="responsive-navbar-nav" />
<Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mr-auto flex-column">
    <Nav.Link as={Link} to="/" href="#Home" >Home</Nav.Link>
    <Nav.Link as={Link} to="Bio" href="#Bio">Bio</Nav.Link>
    {/* <Nav.Link as={Link} to="Workshops" href="#Workshops">Workshops</Nav.Link> */}
    <Nav.Link as={Link} to="Scripts" href="#Scripts">Scripts</Nav.Link>
    <Nav.Link as={Link} to="Screenwriting" href="#Screenwriting">Screenwriting</Nav.Link>
    <Nav.Link as={Link} to="Consulting" href="#Consulting">Script Consulting</Nav.Link>
    <Nav.Link as={Link} to="Music" href="#Music">Music for Film</Nav.Link>
    <Nav.Link as={Link} to="Recommendations" href="#Recommendations">Recommendations</Nav.Link>
    <Nav.Link as={Link} to="Newsletter" href="#Newsletter">Christian Screenwriters' Newsletter</Nav.Link>
    <Nav.Link href="http://ambassadorcommunications.biz/" target="_blank" rel="noopener noreferrer">Ambassador Communications</Nav.Link>
    {/* <Nav.Link as={Link} to="Press" href="#Press">Press</Nav.Link> */}
    <Nav.Link as={Link} to="Store" href="#Store">Store</Nav.Link>
    <Nav.Link as={Link} to="Contact" href="#Contact">Contact</Nav.Link>
  </Nav>
</Navbar.Collapse>
</Navbar>
  )
}
export default Navigation;
